function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { isImage } from '../modules/core/regex.js';
import { nodeOrNew, register, wrapWithAttrCheck } from '../utils/adopter.js';
import { off, on } from '../modules/core/event.js';
import { registerAttrHook } from '../modules/core/attr.js';
import { registerMethods } from '../utils/methods.js';
import { xlink } from '../modules/core/namespaces.js';
import Pattern from './Pattern.js';
import Shape from './Shape.js';
import { globals } from '../utils/window.js';
var Image = /*#__PURE__*/ function(Shape) {
    "use strict";
    _inherits(Image, Shape);
    function Image(node) {
        var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : node;
        _class_call_check(this, Image);
        return _call_super(this, Image, [
            nodeOrNew('image', node),
            attrs
        ]);
    }
    _create_class(Image, [
        {
            // (re)load image
            key: "load",
            value: function load(url, callback) {
                if (!url) return this;
                var img = new globals.window.Image();
                on(img, 'load', function(e) {
                    var p = this.parent(Pattern);
                    // ensure image size
                    if (this.width() === 0 && this.height() === 0) {
                        this.size(img.width, img.height);
                    }
                    if (_instanceof(p, Pattern)) {
                        // ensure pattern size if not set
                        if (p.width() === 0 && p.height() === 0) {
                            p.size(this.width(), this.height());
                        }
                    }
                    if (typeof callback === 'function') {
                        callback.call(this, e);
                    }
                }, this);
                on(img, 'load error', function() {
                    // dont forget to unbind memory leaking events
                    off(img);
                });
                return this.attr('href', img.src = url, xlink);
            }
        }
    ]);
    return Image;
}(Shape);
export { Image as default };
registerAttrHook(function(attr, val, _this) {
    // convert image fill and stroke to patterns
    if (attr === 'fill' || attr === 'stroke') {
        if (isImage.test(val)) {
            val = _this.root().defs().image(val);
        }
    }
    if (_instanceof(val, Image)) {
        val = _this.root().defs().pattern(0, 0, function(pattern) {
            pattern.add(val);
        });
    }
    return val;
});
registerMethods({
    Container: {
        // create image element, load image and set its size
        image: wrapWithAttrCheck(function(source, callback) {
            return this.put(new Image()).size(0, 0).load(source, callback);
        })
    }
});
register(Image, 'Image');
